import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import { IAppState } from "../../../types/stores";
import SharedManageFeatures from "../../admin/companies/edit/SharedManageFeatures";

type Props = {
    isOpen: boolean;
};

const ManageFeaturesModal: React.FC<Props> = ({ isOpen }: Props) => {
    const dispatch = useDispatch();
    const childRef = useRef(null) as any;

    // state
    const [loading, setLoading] = useState(false); //used when loading userFeatures
    const [haveChanges, setHaveChanges] = useState(false);

    // redux
    const roles = useSelector((state: IAppState) => state.session.roles || []);
    const hasSuperAdmin = roles.includes("Super Admin");
    const hasExperianAdmin = roles.includes("Experian Admin");

    const hide = () => {
        dispatch(hideModal("MANAGE_FEATURES"));

        if (childRef.current) {
            childRef.current.handleSetFilter("");
        }
    };

    const saveUpdateFeatures = () => {
        if (childRef.current) {
            childRef.current.handleSaveUpdateFeatures();
        }

        hide();
    };

    return hasSuperAdmin || hasExperianAdmin ? (
        <MaterialModal
            id="manage-modal"
            isOpen={isOpen}
            maxWidth="md"
            fullWidth={true}
            title="Manage Features"
            showPrimaryButton={true}
            cancelButtonText="Close"
            onPrimaryButtonRequest={saveUpdateFeatures}
            isPrimaryButtonDisabled={loading || !haveChanges}
            onClose={hide}
        >
            <SharedManageFeatures
                ref={childRef}
                isOpen={isOpen}
                handleLoading={setLoading}
                handleHaveChanges={setHaveChanges}
                description="Manage your user and company's active features."
                isModal={true}
            />
        </MaterialModal>
    ) : null;
};

export default withModal(ManageFeaturesModal, "MANAGE_FEATURES");
